export const TUser = {
  IS_LOGIN: 'IS_LOGIN',
  TOKEN: 'TOKEN',
  USER_DATA: 'USER_DATA',
  PATCH_USER_DATA: 'PATCH_USER_DATA',
  SET_PERSONAL_INFO: 'SET_PERSONAL_INFO'
};
